export const formatCurrency = (value: number): string => {
  if (value > 1000000000) {
    return `$${(value / 1000000000).toLocaleString(undefined, {
      maximumFractionDigits: 1
    })}B`;
  }
  if (value > 1000000) {
    return `$${(value / 1000000).toLocaleString(undefined, {
      maximumFractionDigits: 1
    })}M`;
  }
  return value.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  });
};
